import axios from 'axios'
import FileDownloads from './service/FileDownloads'

const apiBaseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:70')
  .trim()
  .replace(/\/$/, '')

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const onLoginPage = window.location.pathname === '/auth/login'

    if ((status === 401 || status === 403) && !onLoginPage) {
      sessionStorage.clear()
      window.location.assign('/auth/login')
    }

    return Promise.reject(error)
  }
)

class APIconsume {
  constructor () {
    this.client = apiClient
  }

  async verifyCookieSession () {
    try {
      const response = await this.client.get('/api/dashboard/profile')
      return {
        isValid: response?.data?.status === 'success',
        user: response?.data?.data || null
      }
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return { isValid: false, user: null }
      }
      throw error
    }
  }

  async verifySession (redirectToDashboard = false) {
    const session = await this.verifyCookieSession()
    if (session.isValid && redirectToDashboard) {
      window.location.assign('/dashboard')
    }
    return session.isValid
  }

  async getData (path, config = {}) {
    return await this.client.get(path, config)
  }

  async postData (data, path, type = 'application/json') {
    return await this.client.post(path, data, {
      headers: { 'Content-Type': type }
    })
  }

  async putData (data, path, type = 'application/json') {
    return await this.client.put(path, data, {
      headers: { 'Content-Type': type }
    })
  }

  async patchData (data, path, type = 'application/json') {
    return await this.client.patch(path, data, {
      headers: { 'Content-Type': type }
    })
  }

  async deleteData (path, data) {
    return await this.client.delete(path, { data })
  }

  async GlobalDownload (path, Filename, Extention, headers) {
    const response = await this.client.get(path, {
      responseType: 'blob',
      headers
    })
    return FileDownloads(response, Filename, Extention)
  }

  async GlobalDownloadPost (payload, path, Filename, Extention, headers) {
    const response = await this.client.post(path, payload, {
      responseType: 'blob',
      headers
    })
    return FileDownloads(response, Filename, Extention)
  }
}

export { apiClient, apiBaseUrl }
export default APIconsume
